import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'

import { ThemeProvider } from '@/components/theme-provider'
import { PwaUpdates } from '@/components/pwa-updates'
import { Toaster } from '@/components/ui/toaster'
import { configureApiClient } from '@/lib/api-client'
import { queryClient } from '@/lib/query-client'
import { router } from '@/router'
import { initSentry } from '@/sentry'

import './index.css'

void initSentry()
configureApiClient()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider defaultTheme="system">
      <QueryClientProvider client={queryClient}>
        <PwaUpdates />
        <RouterProvider router={router} />
        <Toaster />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
